export const close_sm = () => (
  <path
    d="M16 8l-8 8m0-8l8 8"
    strokeLinecap="round"
    strokeLinejoin="round"
  />
);
